import { render, staticRenderFns } from "./CartonsCard.vue?vue&type=template&id=1a818b97&scoped=true&"
import script from "./CartonsCard.vue?vue&type=script&lang=js&"
export * from "./CartonsCard.vue?vue&type=script&lang=js&"
import style0 from "./CartonsCard.vue?vue&type=style&index=0&id=1a818b97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a818b97",
  null
  
)

export default component.exports